import type { RootOptions } from 'react-dom/client';

/**
 * Registro de falhas de renderização no console. Só o NOME do erro e a pilha de componentes: o
 * texto da exceção pode trazer dados de cliente (nome, telefone, mensagem), que não devem ir
 * parar em console, extensão de navegador ou captura de suporte. A pilha lista apenas nomes de
 * componentes e arquivos.
 */
export function reportRenderError(error: unknown, componentStack?: string | null): void {
  const name = error instanceof Error ? error.name : 'valor lançado que não é um Error';
  console.error(`Falha de renderização (${name}). Pilha de componentes:${componentStack ?? ''}`);
}

/**
 * Opções do `createRoot`. O React 19 imprime por conta própria o erro capturado por um boundary
 * (com a mensagem da exceção); aqui isso é trocado pelo registro acima.
 */
export const rootErrorOptions: RootOptions = {
  // Já registrado por `ErrorBoundary.componentDidCatch`; o padrão do React imprimiria a exceção.
  onCaughtError: () => undefined,
  // Erro que nenhum boundary pegou (inclusive uma falha do próprio boundary).
  onUncaughtError: (error, info) => reportRenderError(error, info.componentStack),
};
